import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

const tabs = [
  { label: "Insights",      path: "/insights" },
  { label: "Contracts",     path: "/contracts" },
  { label: "Finance",       path: "/finance" },
  { label: "Negotiations",  path: "/negotiations" },
];

const ROLE_BADGES = {
  superadmin:   { label: "Super Admin", bg: "#1B3A5C", color: "#ffffff" },
  client_admin: { label: "Admin",       bg: "#E6F4F1", color: "#0D7377" },
  client_viewer: null, // no badge for viewers
};

export default function NavBar() {
  const { user, userInfo, logout } = useAuth();
  const navigate = useNavigate();

  async function handleLogout() {
    await logout();
    navigate("/login");
  }

  const badge = userInfo?.role ? ROLE_BADGES[userInfo.role] : null;

  return (
    <nav className="bg-white border-b border-gray-200 px-6 flex items-center justify-between h-14 shadow-sm">

      {/* Left — logo + tabs */}
      <div className="flex items-center gap-8">
        <span className="text-xl font-bold" style={{ color: "#1B3A5C" }}>
          BetIntel
        </span>

        <div className="flex items-center gap-1">
          {tabs.map(tab => (
            tab.disabled ? (
              <span key={tab.path}
                className="px-4 py-2 text-sm text-gray-300 cursor-not-allowed"
                title="Coming soon">
                {tab.label}
              </span>
            ) : (
              <NavLink
                key={tab.path}
                to={tab.path}
                className={({ isActive }) =>
                  `px-4 py-2 text-sm rounded-md font-medium transition-colors ` +
                  (isActive
                    ? "text-white"
                    : "text-gray-600 hover:text-gray-900 hover:bg-gray-100")
                }
                style={({ isActive }) =>
                  isActive ? { backgroundColor: "#0D7377" } : {}
                }
              >
                {tab.label}
              </NavLink>
            )
          ))}
        </div>
      </div>

      {/* Right — role badge, client switcher (superadmin only), email, sign out */}
      <div className="flex items-center gap-4">

        {/* Role badge — shown for superadmin and client_admin only */}
        {badge && (
          <span className="text-xs font-medium px-2 py-1 rounded-full"
            style={{ backgroundColor: badge.bg, color: badge.color }}>
            {badge.label}
          </span>
        )}

        {/* Client switcher — superadmin only */}
        {userInfo?.role === "superadmin" && (
          <div className="flex items-center gap-1">
            <span className="text-xs text-gray-400">Client:</span>
            <span className="text-xs font-medium text-gray-600">
              {userInfo?.client_name || "All"}
            </span>
            {/* Full client switcher dropdown to be built when client 2 is onboarded */}
          </div>
        )}

        <span className="text-sm text-gray-500">{user?.email}</span>

        <button onClick={handleLogout}
          className="text-sm text-gray-500 hover:text-gray-900 transition-colors">
          Sign out
        </button>
      </div>
    </nav>
  );
}